// extracted by mini-css-extract-plugin
export default {"close":"PlantNameInput_close__OzPyt"};